import React, { useState, useEffect } from 'react';
import { Download, Book } from 'lucide-react';
import TabsContainer, { Tab } from '@/Components/TabsContainer/TabsContainer';
import LibraryTab from './LibraryTab';
import UploadTab from './UploadTab';
import useContentManagementStore from '@/stores/AdminStore/ContentManagementStore';

const ContentManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('upload');

  const {
    libraryContent,
    recentUploads,
    categories,
    fetchLibraryContent,
    fetchRecentUploads,
    fetchCategories,
  } = useContentManagementStore();

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'library' && !libraryContent) {
      fetchLibraryContent();
    }
  }, [activeTab, libraryContent, fetchLibraryContent]);

  useEffect(() => {
    if (activeTab === 'upload' && !recentUploads) {
      fetchRecentUploads();
    }
    if (activeTab === 'upload' && !categories) {
      fetchCategories();
    }
  }, [activeTab, recentUploads, categories, fetchRecentUploads, fetchCategories]);

  const tabs: Tab[] = [
    {
      id: 'upload',
      label: 'Upload New',
      icon: Download,
      content: <UploadTab />,
    },
    {
      id: 'library',
      label: 'Library',
      icon: Book,
      count: libraryContent?.length || 0,
      content: <LibraryTab />,
    },
  ];

  return (
    <div className="s-admin-content-management-container">
      <TabsContainer
        breadcrumb="Content Management › Upload & Library"
        title="Content Management"
        subtitle="Upload, organize, and manage your learning content assets"
        tabs={tabs}
        defaultTab="upload"
        onTabChange={setActiveTab}
      />
    </div>
  );
};

export default ContentManagement;
